export default {
	termsAndConditions: {
		lastUpdate: '最終更新日: 2024年6月10日',
		content: `
		<p>以下の利用規約は重要です:</p>
		<ul>
			<li>これらは{siteName}における法的権利を確立します。</li>
			<li>{siteName}を使用する際に私たちに付与する権利を説明します。</li>
			<li>{siteName}を使用する際に守らなければならないルールを記述します。</li>
		</ul>
		<p>これらの利用規約、および{privacyPolicyLink}やこれらの利用規約に記載されているその他の文書を注意深く読んでください。</p>
		<p>では、始めましょう...</p>
		<h3>1. {siteNameUpper}の紹介とデータ</h3>
		<p>
			ウェブサイト{websiteLink}（以下、「ウェブサイト」）は、会社{siteName} S.L（以下、「{siteName}」）が所有しています。
			{siteName}は、スペイン法に基づいて設立され、バルセロナのサン・クガット・デル・バリェス、アベニーダ・デ・セルダニョラ75番1号に住所を持ち、CIF番号B-56.768.260を所有し、バルセロナ商業登記簿第49065巻、第0033頁、シートB-606324、初登録されています。
		</p>
		<p>
			{siteName}は、私たちをよりよく知り、提供するサービスを知り、連絡し、必要に応じて契約するためにウェブサイトを提供します。
		</p>
		<h3>2. 利用規約の目的と適用範囲</h3>
		<p>
			これらの利用規約は、{privacyPolicyLink}および{cookiesPolicyLink}とともに、ウェブサイト{websiteLink}の利用を規制する法的枠組みを構成します。これらの利用規約は、いつでも参照、保存、印刷できるように、英語でウェブサイトに掲載されています。
		</p>
		<p>
			{siteName}による個人データの取り扱いに関する質問については、{privacyPolicyLink}および{cookiesPolicyLink}をご覧ください。これらのポリシーも英語で提供されており、いつでも参照、保存、印刷できます。<br />
			{siteName}は、ウェブサイトで第三者のクッキーを使用しています。ウェブ{websiteLink}で使用されているクッキーの種類、目的、およびこれらのクッキーを使用しない場合のブラウザ設定については、{cookiesPolicyLink}をご覧ください。
		</p>
		<p>
			これらの利用規約、および{privacyPolicyLink}と{cookiesPolicyLink}は、現行の適用法規に従って作成されています。特に、情報社会および電子商取引サービスに関する2002年の法律34/2002、ならびに個人データの処理およびこれらのデータの自由な移動に関する2016年4月27日の欧州議会および理事会の規則（EU）2016/679、および指令95/46/ECの廃止に関する規則に準拠しています。
		</p>
		<h3>3. ウェブサイトへのアクセスと承諾</h3>
		<p>
			ウェブサイトへのアクセスは無料です。ただし、インターネットアクセスプロバイダーが提供する通信ネットワークを介して接続する費用に関連する部分を除きます。ウェブサイトを自由に閲覧し、何度でもアクセスできます。サービスを契約したい場合を除き、ウェブサイトへのアクセスおよびナビゲーションには登録が必要ありません。
		</p>
		<p>
			ウェブサイトの使用により、あなたはウェブサイトのユーザー（以下、「ユーザー」）となり、これらの利用規約、およびウェブサイトの{privacyPolicyLink}と{cookiesPolicyLink}を完全に承諾することになります。さらに、サービスを違法な目的で使用しないことに同意します。
		</p>
		<p>
			ウェブサイトにアクセスし、閲覧することにより、あなたは法定年齢に達しており、ウェブサイトにアクセスして使用するために必要な法的能力を有していることを自らの責任で宣言し、これらの利用規約を完全に理解し、無条件に承諾することを宣言します。
		</p>
		<p>
			また、法的理由により、購入が確定された電子文書をアーカイブすることをお知らせします。これらの文書にいつでもアクセスするには、{supportLink}でリクエストしてください。
		</p>
		<h3>4. ウェブサイトの利用条件</h3>
		<p>
			ユーザーは、これらの利用規約、現行法、および善意に従ってウェブサイトを使用することに同意します。したがって、ユーザーは、これらの条件、法律、および善意に反するウェブサイトの使用により生じた損害に対して{siteName}および第三者に責任を負います。
		</p>
		<h3>5. サービスの説明</h3>
		<p>
			{siteName}を通じて、画像編集を行うためのサービスにサブスクリプションすることができます。
		</p>
		<p>
			{siteName}と購入者の間の契約は、原産国の言語で締結されます。<br />
			オンラインサービスでの購入プロセスは次のとおりです:
		</p>
		<ol>
			<li>ユーザー名とパスワードでウェブサイトに登録する必要があります。</li>
			<li>登録時に、価格セクションにある支払いプランのいずれかを選択し、選択したプランに応じてクレジットが付与されます。各クレジットは1枚の画像を編集することができます。</li>
			<li>サービス購入後、ユーザーは管理パネルにアクセスし、次のセクションがあります:
				<ul>
					<li>処理されたすべての画像のリストを含むセクションがあり、何度でも編集し、デバイスにダウンロードできます。</li>
					<li>請求書を確認し、サブスクリプションをキャンセルするためのプランと支払いのセクション。</li>
					<li>アカウントの設定を変更するためのマイアカウントセクション。</li>
				</ul>
			</li>
		</ol>
		<p>
			サービスの購入が完了すると、指定されたアドレスに最大24時間以内に確認メールが送信されます。そのメールには、サービス、サブスクリプションのキャンセル方法、金額、適用税、支払い方法、および適用される利用規約が記載されます。
		</p>
		<h4>5.1 サブスクリプション</h4>
		<p>
			サービスのサブスクリプションは選択したプランによって異なり、終了するまで同じ期間自動的に更新されます。サブスクリプションをキャンセルしない限り、対応する年間サブスクリプション料金をお支払い方法に請求することを許可します。
		</p>
		<p>
			サービスのサブスクリプションはいつでもキャンセルでき、年間請求期間の終了までアクセスを続けることができます。法的に許容される範囲で、支払いは返金不可であり、部分的な年間サブスクリプション期間の返金やクレジットは提供しません。
		</p>
		<h3>6. 価格と税金</h3>
		<p>
			{siteName}で提供される製品の価格はユーロ（€）または購入元の通貨で表示され、購入時の付加価値税（VAT）が適用されます。
		</p>
		<p>
			いずれにせよ、居住国や行為の条件によってはVATが免除または非課税となる場合があります。そのため、注文の最終価格が表示されている価格と異なる場合があります。<br />
			VAT支払いが免除される対象者による購入は、VAT/NIF番号を{supportLink}にメールで送信することにより示され、購入には税が記録されません。
		</p>
		<h3>7. 支払い方法</h3>
		<p>
			購入されたサービスのオンライン支払いはクレジットカードまたはデビットカードで行うことができます。この点で、{siteName}は、オンラインストアの取引がSSL技術を使用した安全な支払いゲートウェイを通じて行われることをお知らせします。
		</p>
		<h3>8. 取消権と返金</h3>
		<h4>8.1. 取消権</h4>
		<p>
			私たちのオンラインサービスで販売されている製品の性質上、QRデジタル形式のソフトウェアであるため、2021年11月16日の王立立法令1/2007の第103条m)に従い、取消権は適用されません。
		</p>
		<h4>8.2. 返金</h4>
		<p>
			ユーザーが選択したプランに関係なく、法的に許容される範囲で支払われた金額は返金不可です。
		</p>
		<p>
			契約されたサービスは、他のサービスユーザーに譲渡または転送することはできません。
		</p>
		<p>
			いずれにせよ、ユーザーは契約期間の終了まで契約されたサービスを利用することができます。
		</p>
		<h3>9. オファーの有効性</h3>
		<p>
			サービスで提供されるサービスとその価格は、このウェブサイトを通じて表示されるサービスカタログにある限り購入可能です。
		</p>
		<p>
			いずれにせよ、{siteName}は、サービスに適切と判断する変更を行う権利を有し、市場の状況に応じて製品やサービスを更新することができます。
		</p>
		<p>
			{siteName}は、予告なしに価格を変更する権利を留保します。サービスの価格の更新にもかかわらず、エラーが含まれる可能性があります。エラーが発生した場合、迅速に修正しますが、サービスに拘束力を持ちません。
		</p>
		<h3>10. 安全性</h3>
		<p>
			上記の通り、購入手続き全体、および個人データと支払いシステムの送信は、安全なページで暗号化されてSSLプロトコルを通じて行われます。
		</p>
		<p>
			私たちは、現時点での技術知識に基づいてサービスの安全性を保証します。ただし、{siteName}は、サービスの将来の完全な安全性を保証することはできません。いずれにせよ、可能な限り早く修正し、適切な是正措置を講じることを約束します。
		</p>
		<p>
			ユーザーのアイデンティティがなりすましの可能性がある状況について、すぐに{supportLink}にメールで通知することに同意します。
		</p>
		<h3>11. 変更と無効</h3>
		<p>
			将来的にサービスの利用規約や機能を更新することがあります。
		</p>
		<p>
			ウェブサイト上の目立つ場所に通知を掲載するか、メールでお知らせします。
		</p>
		<p>
			これらの利用規約のいずれかの条項が全体または一部が無効または無効であると宣言された場合、その条項またはその一部にのみ影響します。他のすべての条項は存続し、その条項またはその一部が存在しないものとみなされます。
		</p>
		<h3>12. 契約から生じる請求および行動</h3>
		<p>
			できる限り、このサービスはスペイン法に準拠します。<br />
			民事訴訟による請求の解決を簡素化し、コストを削減するために、商業会議所および工業会議所の仲裁裁判所の衡平仲裁に従うことを排除しません。この意味で、適用法規に従い、{siteName}は、オンラインで締結された契約について、消費者とインターネットサービス提供者の間で非司法的に解決するための欧州オンライン紛争解決プラットフォームの存在を通知します。このプラットフォームには、次のウェブサイトからアクセスできます:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. 知的財産権と産業財産権</h3>
		<p>
			ウェブサイトとそのコンテンツは、現行の知的財産および/または産業財産に関する国内規制、およびそのような事項に適用される国際条約に基づいて保護されています。{siteName}は、ウェブサイトおよびそのコンテンツに関するすべての知的財産権および産業財産権を所有しているか、適切にライセンスされています。
		</p>
		<p>
			{siteName}の事前の明示的な同意なしに、商業目的かどうかにかかわらず、ウェブサイトやそのコンテンツのいかなる形式の複製、配布、公衆送信、変換、提供、および一般的にその他のすべての搾取行為は厳しく禁止されています。ウェブサイトやそのコンテンツの知的財産権や産業財産権の所有者としての{siteName}の識別データを削除することは明示的に禁じられています。
		</p>
		<p>
			{siteName}は、ウェブサイトおよびそのコンテンツに対するすべての知的財産権および産業財産権を留保し、ウェブサイトやそのコンテンツの違法な使用を防止、追求するために適切な法的措置を講じる権利を有します。いかなる場合も、ウェブサイトやそのコンテンツへのアクセスやユーザーや第三者による使用が、{siteName}による知的財産権や産業財産権の譲渡を意味するものではありません。また、{siteName}がウェブサイトやその違法な使用に対して差し止めを求めない場合、それが黙示的な同意や法的措置の放棄と解釈されることはありません。
		</p>
		<h3>14. 責任と保証</h3>
		<p>
			ユーザーは、これらの利用規約、現行法、および善意に従ってウェブサイトおよびそのコンテンツを使用することに同意します。これらの一般条件、法律、または善意に反するウェブサイトやそのコンテンツのいかなる使用も、経済的目的かどうかにかかわらず、明示的に禁止されています。<br />
			ユーザーは、ウェブサイトやそのコンテンツの使用に起因する損害や損失に対して、{siteName}および第三者に対して責任を負います。
		</p>
		<p>
			ウェブサイトやそのコンテンツがユーザーにアクセス可能になるためには、{siteName}が提供するサービスが必要です。{siteName}がウェブサイトを利用者に提供し続けるために最善を尽くしているにもかかわらず、第三者の影響で中断される、利用できない、または停止されることがあります。そのため、{siteName}はウェブサイトやそのコンテンツへのアクセスの中断やエラーがないこと、最新のバージョンで表示されることを保証しません。したがって、{siteName}は、ウェブサイトやそのコンテンツの中断、エラー、アクセス不能に起因する損害について責任を負いません。
		</p>
		<p>
			いかなる場合でも、{siteName}は、自然災害、不可抗力、緊急事態、ウイルス、有害成分、ブラウザの不具合、ネットワークの停止、コンピュータ侵入、第三者の攻撃など、{siteName}に起因しない原因による損害や損失について責任を負いません。
		</p>
		<h3>15. リンク</h3>
		<p>
			ウェブサイト、プラットフォーム、フォーラム、チャット、ブログ、または外部のソーシャルネットワークがウェブサイトにリンクまたはリンクする場合、それらは{siteName}の許可や監督がないことを明確に通知し、そのリンクやリンクが{siteName}とこれらのウェブサイト、プラットフォーム、フォーラム、チャット、ブログ、または外部のソーシャルネットワークとの間にいかなる種類の関係があることを意味しないことを明示します。
		</p>
		<p>
			いずれにせよ、ウェブサイトへのリンクはホームページまたはウェブサイトのホームページに直接向けられる必要があり、URLをクリックしてホームページやウェブサイトのホームページ全体を表示するため、リンクは完全でフレームやハイパーリンクを使用しないことが必要です。{siteName}はいかなる場合もウェブサイトやそのコンテンツに関連するウェブサイト、プラットフォーム、フォーラム、チャット、ブログ、または第三者のソーシャルネットワークに関する情報やデータに対して責任を負いません。
		</p>
		<p>
			法律、道徳、善良な習慣に反するコンテンツ、特にポルノ、違法、または人権を侵害するコンテンツを含むウェブサイト、プラットフォーム、フォーラム、チャット、ブログ、またはソーシャルネットワークからウェブサイトにリンクすることは明示的に禁じられています。
		</p>
		<p>
			また、ウェブサイトには第三者のウェブサイト、プラットフォーム、フォーラム、チャット、ブログ、またはソーシャルネットワークへのリンクが含まれる場合があります。{siteName}は、第三者のウェブサイトに表示される情報やコンテンツを知るまたは管理するための人的および技術的手段を持っていません。したがって、{siteName}はいかなる場合もリンク先のサイトのコンテンツに対して責任を負いません。また、リンクが有効であることを知っているとみなされることはありません。
		</p>
		<h3>16. データ保護</h3>
		<p>
			{privacyPolicyLink}に記載されているように、{siteName}は、ユーザーのデータを使用し、機密性を尊重し、処理の目的に従って使用し、保存する義務を遵守し、個人データの保護に関する現行の法規に従って、すべての措置を講じます。
		</p>
		<p>
			ウェブサイトは、収集された個人データのセキュリティ、完全性、完全性、正確性、および保護を向上させるために業界標準の技術を使用し、合理的な予防措置を講じて、その情報が紛失または誤用されないようにします。データ保護およびセキュリティに関するルールは、必要に応じて定期的に見直され、改良され、権限を持つ者のみがユーザーが提供する情報にアクセスできるよう努めています。
		</p>
		<p>
			{siteName}によるデータの管理および処理について詳しくは、{privacyPolicyLink}および{cookiesPolicyLink}をご覧ください。
		</p>
		<h3>17. 期間と変更</h3>
		<p>
			これらの利用規約はユーザーに公開されている限り有効であり、完全または一部が変更または更新されると、新しい利用規約がウェブサイトの使用を規制します。
		</p>
		<p>
			{siteName}は、これらの利用規約をいつでも見直し、変更または更新する権利を留保します。これらの利用規約に何らかの変更がある場合、その変更についてウェブサイトのホームページに通知を掲載するか、メールで通知します。
		</p>
		<h3>18. 一般事項</h3>
		<p>
			いかなる場合も、{siteName}が権利を行使しないことが、権利の放棄とみなされることはありません。
		</p>
		<p>
			これらの利用規約に含まれる見出しは、単に参考目的であり、それらの解釈に影響を与えることはありません。
		</p>
		<p>
			これらの利用規約のいずれかの条項が、司法または行政機関によって全体または一部が無効、濫用または執行不可能と宣言された場合、その宣言は当該条項にのみ影響を与え、その条項は存在しないものとみなされますが、他の条件にはいかなる影響も与えず、存続します。
		</p>
		<p>
			これらの利用規約、および{privacyPolicyLink}と{cookiesPolicyLink}は、常に現行のスペイン法に準拠します。
		</p>
		<h3>19. カスタマーサービス</h3>
		<p>
			ご不明な点、事故、苦情については、次の方法でお問い合わせください:<br />
			メール: {supportLink}<br />
			郵送先住所: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: '最終更新日: 2024年6月10日',
		content: `
			<h3>1. 責任者と説明</h3>
			<h5>1.1. 責任者</h5>
			<p>このサイトの処理責任者はRemove Background S.L（以下、Remove Backgroundまたはサービス）であり、住所はAv. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spainです。</p>
			<p>NIF: B56768260<br> メール: {supportLink}</p>

			<h5>1.2. 説明</h5>
			<p>Remove Backgroundのプライバシーポリシー（以下「プライバシーポリシー」）を受け入れることは、私たちのウェブサイトの利用とサービスの提供（以下「サービス」）のための必要条件です。<br>
				このプライバシーポリシーは、Remove Backgroundのユーザーとしてのあなたの個人情報および非個人情報の収集、処理、利用を規制します。<br>
				Remove Backgroundは、現地およびヨーロッパの現行法、およびその施行規則を遵守して、あなたの個人データを処理します。</p>

			<h3>2. 収集される情報</h3>
			<p>私たちのウェブサイトへのアクセスは、情報を提供する必要はありませんが、登録および/またはプランの契約には一部の個人情報を提供する必要があります。サービスによって収集される情報（個人情報および非個人情報）は、それによって異なる場合があります。<br>
				サービスによって収集される個人情報および非個人情報は、1）自動的に収集されるもの、2）自発的に提供されるもの、および3）第三者から提供されるものの3つの方法で私たちに届きます。</p>

			<h5>2.1. 自動的に収集される情報</h5>
			<p>この情報は以下を含みます:</p>
			<ul>
				<li>クッキーや類似のメカニズムを通じてデバイスに保存される情報は、常にあなたの同意または他の法的根拠に基づいて収集されます。詳細については、クッキーポリシーをご覧ください。</li>
				<li>接続元のIPアドレス、使用されるデバイスの種類とその特性、オペレーティングシステムのバージョン、ブラウザの種類、言語、日付、国、リクエストの時間、出発元URL、到達先URL、使用されるモバイルネットワークなど。</li>
				<li>サービスの利用データおよび使用中に検出された可能性のあるエラー。</li>
				<li>さらに、Remove Backgroundは、Google LLCが提供する分析サービスであるGoogle Analyticsを使用しています。これらのサービスの提供のために、クッキーを使用して情報（ユーザーのIPアドレスを含む）を収集し、それをwww.google.comに記載された条件に従ってGoogleが送信、処理、保存します。この情報は、法的要件に基づいて第三者に送信される場合や、Googleが情報を処理する第三者に送信される場合があります。</li>
			</ul>
			<p>いずれにせよ、<a href="{externalLink: disableGoogleAnalyticsLink}">ここ</a>からGoogle Analyticsのクッキーを無効にできます。</p>

			<h5>2.2. 自発的に提供される情報</h5>
			<p>この情報は以下を含みます:</p>
			<ul>
				<li>すべてのデータは必須です。</li>
				<li>Remove Backgroundでウェブ登録を完了するために必要な情報: 名前、姓、住所、メールアドレスなど。</li>
				<li>すべてのデータは必須です。</li>
				<li>サービスの契約を完了するために必要な情報（例: メールアドレス、クレジットカードまたはデビットカード番号）。</li>
				<li>サービスの連絡または意見チャンネルを通じて送信されるメッセージに含まれる可能性のある情報（例: 名前、メールアドレス）。</li>
			</ul>

			<h5>2.3. 第三者から提供される情報</h5>
			<p>この情報は以下を含みます:</p>
			<ul>
				<li>支払いシステムまたはクレジットカードプロセッサーから提供される情報（例: 購入の時間、金額）。</li>
			</ul>

			<h3>3. 権利と目的</h3>
			<p>フォームの記入は任意です。ただし、必須フィールド（通常はアスタリスクで示されます）を記入しない場合、一部のサービス機能の利用ができないか制限されます。<br>
				提供された個人データは、Remove Backgroundの処理活動記録に組み込まれ、要求に対応するため、要求されたサービスを提供するため、会社の活動およびサービスに関連する事項について情報を提供するために処理されます。<br>
				いつでも個人データのアクセス、訂正、削除、処理の制限、反対、データポータビリティの権利を行使することができます。メールアドレスは: {supportLink}または郵送先住所: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spainです。<br>
				いずれの場合も、氏名および姓、必要に応じてDNIまたは国民IDのコピーを添付する必要があります。<br>
				特定の目的に同意を与えた場合、いつでも同意を撤回する権利があります。ただし、同意の撤回前の処理の合法性には影響しません。<br>
				さらに、Remove Backgroundがデータの取り扱いに問題があると感じた場合、<a href="{knowYourRightsLink}">データ保護機関</a>に苦情を申し立てることができます。スペインの場合は、<a href="{aepdLink}">スペインデータ保護機関</a>です。</p>

			<h3>4. 年齢</h3>
			<p>オンラインサービスの利用に関して、あなたは法定年齢に達しており、この契約に拘束され、サイトを利用規約に従って使用するための法的能力を有していることを宣言します。<br>
				サービスの利用前後に提供するすべての情報が真実、完全、正確であることを宣言します。</p>

			<h3>5. データの使用</h3>
			<p>Remove Backgroundは収集されたデータを以下の目的で使用します:</p>
			<ul>
				<li>サービスの管理と更新（法的根拠はサービスの維持と良好な状態の維持に対する正当な利益）。</li>
				<li>あなたの質問に対応する（法的根拠はユーザーの要求と疑問に対応する正当な利益）。</li>
				<li>あなたの支払いを処理する（契約が法的根拠）。</li>
				<li>契約されたサービスを提供する（契約が法的根拠）。</li>
				<li>サービスのセキュリティを維持し、違法活動を調査し、利用規約を施行し、法執行機関を支援する（法的根拠はサービスとそのユーザーのセキュリティを保証し維持する正当な利益）。</li>
			</ul>
			<p>Remove Backgroundは、自動化された意思決定を使用しませんが、商業目的やパーソナライズされたオファーを提供するための正当な利益に基づいて基本的なユーザープロファイルを生成することがあります。<br>
				また、Remove Backgroundは、集計および匿名化されたデータの形でユーザー情報を第三者に表示することがあります。さらに、ユーザーの使用状況に関する統計や人口統計情報を第三者と共有することがあります。しかし、これにより第三者が個人的にあなたを特定することはできません。</p>

			<h5>5.1. メールおよび連絡フォームで</h5>
			<p>ウェブサイトはSSL暗号化を備えており、ユーザーが標準的な連絡フォームを通じて個人データを安全に送信できるようにします。<br>
				収集された個人データは、自動処理され、Remove Backgroundが所有する処理活動記録の対応ファイルに組み込まれます。</p>
			<p>この点について:</p>
			<ul>
				<li>メッセージの発信元を確認し、適切な推奨を提供するために、IPアドレスを受け取り（例: 正しい言語で情報を表示）、不正行為を検出するため（例: サービスへのサイバー攻撃の試み）、ISPに関連するデータも受け取ります。</li>
				<li>また、電話、メール、およびその他の指定された連絡手段を通じてデータを提供することができます。</li>
			</ul>
			<p>使用される支払い手段に関して:</p>
			<ul>
				<li>私たちの支払いサービスプロバイダーは、クレジットカードまたはデビットカードです。サービスやそのスタッフは、ユーザーが第三者に提供する銀行情報（例: クレジットカード番号）にアクセスすることはありません。</li>
			</ul>

			<h3>6. データの保持</h3>
			<p>以下に、サービスによって処理されるデータの保持期間を示します:</p>
			<ul>
				<li>分散データは削除期間なしで保持されます。</li>
				<li>
					顧客データは必要最小限の期間保持され、以下の期間まで保持される場合があります:
					<ul>
							<li>5年、民法第1964条に基づき（特定の期間がない個人的行為）。</li>
							<li>6年、商法第30条に基づき（例: 会計帳簿または請求書）。</li>
					</ul>
				</li>
				<li>ユーザーデータは、リクエストに対応するために最大12か月間保持されます。</li>
			</ul>

			<h3>7. 第三者とのデータ共有</h3>
			<p>サービスの一部を管理する第三者が存在します。<br>
				Remove Backgroundは、適用される限りこのプライバシーポリシーに準拠するように要求し、自身のポリシーも持つようにします。ただし、Remove Backgroundはそのポリシーの遵守に責任を負いません。<br>
				特定の状況下で、Remove Backgroundは収集された個人情報を第三者と共有、使用、保存することがあります:</p>
			<ul>
				<li>サービスを提供するため:</li>
			</ul>
			<p>支払いサービス、ウェブホスティング、ビジネス分析、カスタマーサービス、またはウェブマーケティングなどの機能を私たちの代わりに実行するサービスプロバイダー。これらのサービスプロバイダーは、機能を実行するために必要な情報を収集しアクセスできますが、その情報を他の目的で共有または使用することはできません。</p>
			<ul>
				<li>適切な当局と協力するため:</li>
			</ul>
			<p>法的要件を満たすために必要であると信じる場合に、情報を提供します。いずれの場合も、厳密に必要な情報のみを提供します。</p>

			<h3>8. セキュリティ対策</h3>
			<p>Remove Backgroundは、収集された個人情報および非個人情報のセキュリティと完全性を保護するために、必要な技術的および組織的対策をすべて講じています。<br>
				いかなる場合でも、収集された情報の絶対的なセキュリティを保証することはできないため、共有する情報について常に常識を持って協力する必要があります。<br>
				情報の削除後でも、キャッシュに表示されたり、他のユーザーによってコピーまたは保存された場合は、個人情報および非個人情報が表示されることを理解し、認識しています。</p>

			<h3>9. プライバシーポリシーの変更</h3>
			<p>将来的にこのプライバシーポリシーを更新することがあります。変更については、提供されたメールアドレスに通知を送信するか、ウェブサイトの目立つ場所に通知を掲載します。</p>

			<h3>10. 連絡先</h3>
			<p>このプライバシーポリシーについて質問がある場合は、次の方法でお問い合わせください:</p>
			<p>メール: {supportLink}<br> 
				住所: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain。</p>
		`
	},
	gdpr: {
		lastUpdate: '最終更新日: 2024年6月10日',
		content: `
			<h3>1. 責任者は誰で、どのように連絡するか？</h3>
			<p>このサイトの管理者は、Remove Background S.Lであり、住所はAv. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spainです。</p>
			<p>メールでの連絡は、{supportLink}です。</p>

			<h3>2. どのようなデータが収集されますか？</h3>
			<p>
				クッキーを通じてデバイスに自動的にデータを収集し、分析を行います。接続元のIP、使用するデバイスの種類とその特性、オペレーティングシステムのバージョン、ブラウザの種類、言語、日付、国、リクエストの時間、出発元URL、到達先URL、使用するモバイルネットワークなども収集します。<br>
				ユーザーが自発的に提供する情報（例: 名前、姓、メールアドレス、銀行情報など）も収集します。これにより、私たちに連絡し、サービスに登録し、サブスクリプションを購入できます。
			</p>

			<h3>3. 収集されたデータは何に使用されますか？</h3>
			<p>
				サービスは収集されたデータを使用して、サービスを管理および更新し、あなたの要求に対応し、ニュースレターやプロモーションオファーをメールで送信し、プラットフォームへの登録を管理し、サブスクリプションに関連するサービスを提供し、支払いを処理し、対応する請求書を発行し、サービスのセキュリティを維持し、違法活動を調査し、利用規約を施行し、法執行機関を支援します。
			</p>

			<h3>4. データはどのくらいの期間保持されますか？</h3>
			<ul>
				<li>分散データは削除期間なしで保持されます。</li>
				<li>
					顧客データは必要最小限の期間保持され、以下の期間まで保持される場合があります:
					<ul>
						<li>5年、民法第1964条に基づき（特定の期間がない個人的行為）。</li>
						<li>6年、商法第30条に基づき（例: 会計帳簿または請求書）。</li>
					</ul>
				</li>
				<li>ユーザーデータは、リクエストに対応するために最大12か月間保持されます。</li>
				<li>サービスがユーザーの同意を得てソーシャルネットワークのページやプロフィールにアップロードしたユーザーデータは、ユーザーが同意を撤回するまで保持されます。</li>
			</ul>

			<h3>5. ユーザーの権利は何ですか？</h3>

			<p>
				アクセス権: 関係者は、データ管理者から自分に関する個人データが処理されているかどうかの確認を得る権利があります。
			</p>
			<p>
				訂正権: 関係者は、データ管理者から自分に関する不正確な個人データの訂正を遅滞なく求める権利があります。また、関係者は不完全な個人データを補完する権利もあります。
			</p>
			<p>
				削除権: 関係者は、自分に関する個人データの削除を遅滞なく求める権利があります。
			</p>
			<p>
				データ処理の制限権: 関係者が自分のデータの処理を制限する権利には2つの側面があります。1）個人データの正確性に異議を唱えた場合、データ管理者がそれを確認する期間、2）データ管理者が正当な利益または公共の利益に基づいて個人データを処理している場合、データ管理者が関係者の利益を上回る理由があるかどうかを確認する期間です。
			</p>
			<p>
				データポータビリティ権: 関係者は、自分がデータ管理者に提供した個人データを、構造化された、一般的に使用される機械可読形式で受け取り、それを別のデータ管理者に転送する権利があります。
			</p>
			<p>
				この点で、関係者は、技術的に可能な場合には、個人データをデータ管理者から直接別のデータ管理者に転送する権利もあります。
			</p>

			<h3>6. 権利を行使する方法は？</h3>

			<p>
				いつでも個人データの権利を行使することができます。メールアドレスは: {supportLink} または郵送先住所: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spainです。いずれの場合も、氏名および姓、必要に応じてDNIまたは国民IDのコピーを添付する必要があります。<br>
				さらに、Remove Backgroundがデータの取り扱いに問題があると感じた場合、<a href="{knowYourRightsLink}">データ保護機関</a>に苦情を申し立てることができます。スペインの場合は、<a href="{aepdLink}">スペインデータ保護機関</a>です。
			</p>

			<h3>7. セキュリティ対策は採用されていますか？</h3>
			<p>
				サービスは、収集された個人情報および非個人情報のセキュリティと完全性を保護するために、必要な技術的および組織的対策をすべて講じています。<br>
				いかなる場合でも、サービスは収集された情報の絶対的なセキュリティを保証することはできないため、共有する情報について常に常識を持って協力する必要があります。<br>
				情報の削除後でも、キャッシュに表示されたり、他のユーザーによってコピーまたは保存された場合は、個人情報および非個人情報が表示されることを理解し、認識しています。
			</p>

			<h3>8. 個人データの移転や国際移転はありますか？</h3>

			<p>
				データの移転や国際移転は行いません。ただし、サービスの一部を管理する第三者が存在し、適用される限りこのプライバシーポリシーに準拠し、自身のポリシーも持つようにします。これらの第三者は、ウェブホスティング、分析監視、またはウェブ開発などの機能を私たちの代わりに実行するサービスプロバイダーです。<br>
				また、法的要件を満たすために必要であると信じる場合に、情報を提供します。いずれの場合も、厳密に必要な情報のみを提供します。
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: '最終更新日: 2024年6月21日',
		content: `
			<h3>概要</h3>
			<ul>
			    <li>使用されるクッキー: <strong>自社および第三者</strong></li>
			    <li>統計を取得するために使用されるか？ <strong>はい、サービスの管理を改善するための正当な利益に基づいています。</strong></li>
			    <li>このウェブサイトを通じてクッキーをインストールする第三者サービス: <strong>Google、Google Analytics、Cloudflare、およびStripe。</strong></li>
			</ul>

			<h3>クッキーの設定と無効化の方法</h3>
			<p>
			    ウェブブラウザからデバイスにインストールされたクッキーを許可、ブロック、削除することができます。デバイスにクッキーをインストールしない場合、閲覧体験が悪化する可能性があります。以下に、各ブラウザでクッキーを設定する方法を示します:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. 種類と用途</h3>
			<p>サービスは、自社および第三者のクッキーを使用して、閲覧体験を向上させ、サービスを提供し、ウェブサイトの使用に関する統計を取得します。</p>

			<h3>2. クッキーとは何か、何に使用されるのか？</h3>
			<p>
			    クッキーは、コンピュータ、モバイル、またはタブレットのウェブブラウザに送信されるテキストファイルであり、閲覧履歴を保存および取得するために使用されます。例えば、ユーザー名やパスワード、プロファイルの設定を記憶するために使用されます。
			</p>

			<h3>3. クッキーの種類は何ですか？</h3>
			<p>管理者による分類:</p>
			<ul>
			    <li>自社クッキー; 自社の設備やウェブドメインからブラウザに送信されます。</li>
			    <li>第三者クッキー; 自社が直接管理していない設備やウェブドメインからブラウザに送信され、第三者（例: Google）によって管理されます。</li>
			</ul>
			<p>アクティブな期間による分類:</p>
			<ul>
			    <li>セッションクッキー; ウェブサイトを離れるまでブラウザのクッキーファイルに保持され、デバイスには残りません。</li>
			    <li>永続クッキー; デバイスに保持され、ウェブサイトに再訪するたびに読み取られます。これらのクッキーは特定の日付以降は機能しなくなります。</li>
			</ul>
			<p>目的による分類:</p>
			<ul>
			    <li>技術的クッキー; 閲覧を改善し、ウェブサイトの正常な動作を保証します。</li>
			    <li>パーソナライゼーションクッキー; 一連の基準に基づいてサービスへのアクセスを事前設定された特性で許可します。</li>
			    <li>分析クッキー; 提供されるサービスの使用を測定し、統計的に分析します。</li>
			</ul>
			<p><strong>remove-background.com</strong>によって使用される第三者クッキーの一覧</p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: 彼らのクッキー（NIDやCONSENT）は、Google以外での広告の表示方法をパーソナライズしたり、検索結果の表示言語などの情報を保存したりするために使用されます。<br><a href="{externalLink: googleCookieTypes}">Googleがさまざまなサービスで使用するクッキーの詳細</a>。
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: 彼らのクッキー（例: _ga）は、ユーザーがウェブサイトを訪れる回数や方法、時間、出発元、到達先などをカウントします。<br>
			        いずれにせよ、<a href="{externalLink: disableGoogleAnalytics}">ここ</a>からGoogle Analyticsのクッキーを無効にできます。
			    </li>
			    <li>Cloudflare: Cloudflareのクッキーポリシーと使用については、<a href="{externalLink: cloudflareCookiesPolicy}">このリンク</a>をクリックしてください。</li>
			    <li>Stripe: Stripeのクッキーポリシーと使用についての情報は、<a href="{externalLink: stripeCookiesPolicy}">こちら</a>をご覧ください。</li>
			</ul>
		`
	}
};
